export const version = '2.38.5';
//# sourceMappingURL=version.js.map